import React, { forwardRef } from 'react';
import {
  View,
  TextInput,
  StyleSheet,
  TextInputProps,
  ViewStyle,
  StyleProp,
} from 'react-native';
import { theme } from '../constants/theme';
import { hp } from '../helpers/common';

type InputProps = TextInputProps & {
  containerStyle?: StyleProp<ViewStyle>;
  icon?: React.ReactNode;
};

const Input = forwardRef<TextInput, InputProps>(
  ({ containerStyle, icon, style, multiline, ...rest }, ref) => {
    return (
      <View style={[
        styles.container, 
        multiline && styles.multilineContainer,
        containerStyle
      ]}>
        {icon}
        <TextInput
          ref={ref}
          multiline={multiline}
          textAlignVertical={multiline ? 'top' : 'center'}
          style={[
            { 
              flex: 1, 
              color: theme.colors.text, // Use the good theme text color (#1F2937)
              fontSize: hp(1.6),
              backgroundColor: 'transparent',
              paddingVertical: multiline ? 12 : 0, // More padding for multiline
            }, 
            style
          ]}
          placeholderTextColor={theme.colors.textLight} // Use theme text light color (#6B7280)
          selectionColor="#E91E63" // Pink selection color
          {...rest}
        />
      </View>
    );
  }
);

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    height: hp(7.2),
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 0.4,
    borderColor: theme.colors.grayDark,
    borderRadius: theme.radius.xxl,
    borderCurve: 'continuous',
    paddingHorizontal: 18,
    gap: 12,
    backgroundColor: '#FFFFFF', // White background
  },
  multilineContainer: {
    height: 'auto',
    minHeight: hp(15),
    alignItems: 'flex-start',
    paddingVertical: 12,
  },
});

export default Input;
